<template>
  <div class="card card-material card-type">
    <div v-if="loadingFilters" class="card-body card-material" :class="{ 'active': isActive }">
      <font-awesome-icon class="font-awesome-icon" icon="spinner" spin/>
    </div>

    <div v-if="filters && !loadingFilters" @click="openFilter()" class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div class="card-title card-material-title" :class="{ 'clear-select': filterFirst }">
        <template v-if="showFilter || !material.bruto">Soort panelen</template>
        <template v-else>Soort bruto persplaten</template>
        <div v-if="filterFirst" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && filterFirst" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter" class="select-type row">
        <div v-for="filter in filters" v-bind:key="filter.name" v-on:click.stop.prevent="select(filter.name, filter.bruto)" class="card card-select card-body col-md-6 m-md-1" :class="{ 'selected': filter.name === filterFirst && filter.bruto === material.bruto }">
          <div class="card-type">
            {{ filter.title }}
          </div>
        </div>
      </div>

      <div v-if="showFilter" class="card-title card-material-title" :class="{ 'clear-select': filterFirst }">
        Soort bruto persplaten
      </div>

      <div v-if="showFilter" class="select-type row">
        <div v-for="filter in filtersBruto" v-bind:key="filter.name" v-on:click.stop.prevent="select(filter.name, filter.bruto)" class="card card-select card-body col-md-6 m-md-1" :class="{ 'selected': filter.name === filterFirst && filter.bruto === material.bruto }">
          <div class="card-type">
            {{ filter.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_FILTER_DELIVERYPROGRAM, SET_MATERIAL_FILTER_FIRST, SET_MATERIAL_BRUTO, SET_MATERIAL_FILTER_SECOND, SET_MATERIAL_FILTER_THIRD, SET_MATERIAL_THICKNESS, SET_MATERIAL_PRODUCT, MUTATE_SIDE_1, MUTATE_SIDE_2 } from '../../../store/types'
  import { EventBus } from '../../../bus'

  export default {
    data() {
      return {
        showFilter: false
      }
    },
    computed: {
      selectedName() {
        if (this.filterFirst) {
          return this.filterFirst
        }

        return ''
      },
      loadingFilters() {
        return this.$store.getters.loadingFilters
      },
      filterDeliveryProgram() {
        return this.$store.getters.filterDeliveryProgram
      },
      filterFirst() {
        return this.$store.getters.filterFirst
      },
      isActive() {
        return this.showFilter || (!this.filterFirst && !this.$store.getters.filterSecond)
      },
      filters() {
        return this.$store.getters.filters
      },
      filtersBruto() {
        return this.$store.getters.filtersBruto
      },
      products() {
        return this.$store.getters.products
      },
      material() {
        return !this.$store.getters.material ? false : this.$store.getters.material
      }
    },
    methods: {
      select(select, bruto = false) {
        if (select !== this.filterFirst || bruto !== this.material.bruto) {
          // Reset the other material filters
          this.$store.dispatch(SET_MATERIAL_FILTER_DELIVERYPROGRAM, null)
          this.$store.dispatch(SET_MATERIAL_FILTER_SECOND, null)
          this.$store.dispatch(SET_MATERIAL_FILTER_THIRD, null)
          this.$store.dispatch(SET_MATERIAL_THICKNESS, null)
          this.$store.dispatch(SET_MATERIAL_PRODUCT, null)

          // Update the material filter
          this.$store.dispatch(SET_MATERIAL_FILTER_FIRST, select)
          this.$store.dispatch(SET_MATERIAL_BRUTO, bruto)
          if (select.indexOf('HPL') === -1 && this.material) {
            // In case of changing selection: Reset the toplayers, if new material is not a HPL
            this.$store.commit(MUTATE_SIDE_1, null)
            this.$store.commit(MUTATE_SIDE_2, null)
          }
        }
        this.showFilter = false
      },
      openFilter() {
        if (this.filterFirst && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.filterFirst) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.disablePanelInput && !this.filterFirst) ? true : (!this.filterFirst) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.filterFirst

      EventBus.$on('filterfirst-select-one', data => {
        // Check if only one option is possible, then select it
        if (this.filters && this.filters.length === 1) {
          this.select(this.filters[0])
        }
      })
    }
  }
</script>

<style lang="scss" scoped>
</style>
